import React from "react";
import { StyledOnlyAllocationAllowedAlert } from "./index.styled";

export const OnlyAllocationAllowedAlert = () => {
  return (
    <StyledOnlyAllocationAllowedAlert
      type="warning"
      closable
      title="Only allocation can be used to ship to Canada"
    >
      Please use your allocation as payment, or ship to a different location.
    </StyledOnlyAllocationAllowedAlert>
  );
};
